import { s as styleInject, c as __extends, m as makeDOMEvent, _ as __rest, a as __assign, p as passThroughProps } from './index-7f1490f0.js';
import React from 'react';
import AceEditor from 'react-ace';
import { config } from 'ace-builds';
import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-min-noconflict/ext-searchbox';
import 'ace-builds/src-min-noconflict/mode-json';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { C as Collapse, E as Expand } from './rich-editor-5bd4b28f.js';
import '@leafygreen-ui/button';
import 'react-dd-menu';
import 'react-confirm';
import '@leafygreen-ui/checkbox';
import '@leafygreen-ui/modal';
import '@leafygreen-ui/typography';
import 'react-fontawesome';
import 'react-transition-group';
import '@leafygreen-ui/confirmation-modal';
import '@leafygreen-ui/text-input';
import '@leafygreen-ui/banner';
import '@leafygreen-ui/icon';
import '@leafygreen-ui/palette';
import '@leafygreen-ui/code';
import '@leafygreen-ui/icon/dist/X';
import '@leafygreen-ui/icon-button';
import '@leafygreen-ui/select';
import '@leafygreen-ui/badge';
import '@leafygreen-ui/icon/dist/Plus';
import 'moment';
import '@leafygreen-ui/copyable';
import 'react-tooltip';
import '@leafygreen-ui/toast';
import 'baas-admin-sdk';
import '@leafygreen-ui/radio-box-group';
import 'cron-parser';
import 'react-select';
import '@leafygreen-ui/toggle';
import '@leafygreen-ui/tooltip';
import 'semver/functions/coerce';
import 'semver/functions/gte';
import '@leafygreen-ui/card';
import 'react-through';

var css_248z = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-rich-json-editor {\n  position: relative;\n  flex-grow: 1;\n  flex-shrink: 0;\n}\n.tb-rich-json-editor-fullscreen {\n  height: 100% !important;\n  width: 100% !important;\n  flex-grow: 1;\n  flex-shrink: 0;\n  top: 0;\n  left: 0;\n  z-index: 1002;\n}\n.tb-rich-json-editor-container {\n  min-height: 170px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #bfbfbe;\n  position: relative;\n}\n.tb-rich-json-editor-container > div {\n  font: 13px / normal 'Menlo', 'Monaco', 'Consolas', 'Courier New', 'Ubuntu Mono', 'source-code-pro', monospace;\n}\n.tb-rich-json-editor-container-is-error {\n  border-color: #ef4c4c;\n  box-shadow: 0 2px 6px pink;\n}\n.tb-rich-json-editor-container-fullscreen {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  z-index: 1010;\n}\n.tb-rich-json-editor-container-fullscreen .tb-expand-collapse {\n  z-index: 1005;\n}\n";
styleInject(css_248z);

config.set('basePath', 'https://cdn.jsdelivr.net/npm/ace-builds@1.4.12/src-min-noconflict/');
config.setModuleUrl('ace/mode/json_worker', 'https://cdn.jsdelivr.net/npm/ace-builds@1.4.12/src-min-noconflict/worker-json.js');
var TestSelector;
(function (TestSelector) {
    TestSelector["BottomGutter"] = "bottom-gutter";
    TestSelector["Container"] = "editor-container";
})(TestSelector || (TestSelector = {}));
var defaultProps = {
    className: '',
    editorClassName: undefined,
    height: '100px',
    width: '100%',
    name: undefined,
    value: '',
    completer: undefined,
    isExpanded: false,
    error: false,
    readOnly: false,
    id: undefined,
    minLines: undefined,
    maxLines: undefined,
    onSave: function () { },
    onChange: function () { },
};
var RichJSONEditor = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.aceEditorRef = React.createRef();
                _this.state = { colNumber: 0, lnNumber: 0, isExpanded: _this.props.isExpanded };
                _this.setCursorValues = function (editor) {
                    if (editor) {
                        var cursor = editor.selection.getCursor();
                        _this.setState({ colNumber: cursor.column, lnNumber: cursor.row });
                    }
                };
                _this.expand = function () {
                    _this.setState(function (prevState) { return ({
                        isExpanded: !prevState.isExpanded,
                    }); });
                };
                return _this;
            }
            class_1.prototype.componentDidMount = function () {
                var completer = this.props.completer;
                if (this.aceEditorRef.current) {
                    if (completer) {
                        this.aceEditorRef.current.editor.completers.push(completer);
                    }
                    this.aceEditorRef.current.editor.commands.removeCommands(['gotoline']);
                }
            };
            class_1.prototype.componentDidUpdate = function () {
                window.dispatchEvent(makeDOMEvent('resize'));
            };
            class_1.prototype.render = function () {
                var _this = this;
                var _a = this.props, height = _a.height, id = _a.id, readOnly = _a.readOnly, width = _a.width, className = _a.className, editorClassName = _a.editorClassName, error = _a.error, onChange = _a.onChange, value = _a.value, minLines = _a.minLines, maxLines = _a.maxLines, name = _a.name, rest = __rest(_a, ["height", "id", "readOnly", "width", "className", "editorClassName", "error", "onChange", "value", "minLines", "maxLines", "name"]);
                var _b = this.state, colNumber = _b.colNumber, lnNumber = _b.lnNumber, isExpanded = _b.isExpanded;
                var container = classNames(className, {
                    'tb-rich-json-editor-container-fullscreen': isExpanded,
                    'tb-rich-json-editor-container-is-error': error,
                    'tb-rich-json-editor-container': !isExpanded,
                });
                var aceEditorProps = {
                    className: classNames(editorClassName, {
                        'tb-rich-json-editor-fullscreen': isExpanded,
                        'tb-rich-json-editor': !isExpanded,
                    }),
                    theme: 'prism',
                    mode: 'json',
                    name: name || id,
                    readOnly: readOnly,
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    editorProps: { $blockScrolling: Infinity },
                    commands: [
                        // Use arrow functions to bind component 'this' to command exec's. That circumvents
                        // what I think is a react-ace issue where react-ace does not update command
                        // functions. By passing in an arrow function with binded 'this' the command
                        // exec will have access to up to date prop functions through the 'this' reference. -HK
                        {
                            name: 'save',
                            bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                            exec: function () { return _this.props.onSave(); },
                        },
                    ],
                    height: height,
                    width: width,
                    value: value,
                    onChange: onChange,
                    onCursorChange: function () { var _a; return _this.setCursorValues((_a = _this.aceEditorRef.current) === null || _a === void 0 ? void 0 : _a.editor); },
                    minLines: minLines,
                    maxLines: isExpanded ? undefined : maxLines,
                    onLoad: this.setCursorValues,
                    showPrintMargin: false,
                    setOptions: { useWorker: !process.env.DISABLE_TOOLBOX_ACE_WORKER },
                };
                return (React.createElement("div", __assign({ className: container, "data-test-selector": TestSelector.Container }, passThroughProps(rest)),
                    React.createElement("div", { className: "tb-expand-collapse" },
                        React.createElement("div", { role: "button", tabIndex: -1, className: "tb-expand-collapse-button", onClick: this.expand }, this.state.isExpanded ? React.createElement(Collapse, null) : React.createElement(Expand, null))),
                    React.createElement(AceEditor, __assign({}, aceEditorProps, { ref: this.aceEditorRef })),
                    React.createElement("span", { className: "tb-rich-editor-bottom-gutter", "data-test-selector": TestSelector.BottomGutter },
                        "Ln ",
                        lnNumber + 1,
                        " Col ",
                        colNumber + 1)));
            };
            return class_1;
        }(React.Component)),
        _a.propTypes = {
            className: PropTypes.string,
            editorClassName: PropTypes.string,
            completer: PropTypes.any,
            error: PropTypes.bool,
            id: PropTypes.string,
            onSave: PropTypes.func,
            readOnly: PropTypes.bool,
            height: PropTypes.string,
            width: PropTypes.string,
            name: PropTypes.string,
            value: PropTypes.string,
            minLines: PropTypes.number,
            maxLines: PropTypes.number,
            isExpanded: PropTypes.bool,
            onChange: PropTypes.func,
        },
        _a.defaultProps = defaultProps,
        _a;
})();

export { TestSelector, RichJSONEditor as default };
//# sourceMappingURL=RichJSONEditor-11415e59.js.map
